import { GET_BACKGROUND_REPORT, GET_ASSESMENT_DATA_REPORT, GET_CLINICAL_INTERVIEW, GET_COLLATERAL_REPORT, GET_DIAGNOSE, GET_FORMULATION, GET_MENNTAL_STATUS_EXAMINATION, GET_RECOMMENDATION, GET_STANRADISED_ASSESSMENT, PATIENT_ASSESSMWNT_RECOMMENDED, GET_BACKGROUND_REPORT_STREAM, GET_ASSESMENT_DATA_REPORT_STREAM, GET_MENNTAL_STATUS_EXAMINATION_STREAM, GET_STANRADISED_ASSESSMENT_STREAM, GET_CLINICAL_INTERVIEW_STREAM, GET_FORMULATION_STREAM, GET_DIAGNOSE_STREAM, GET_RECOMMENDATION_STREAM, PATIENT_ASSESSMWNT_RECOMMENDED_STREAM } from "../action/apiPath";

export const record_sessions_clinical_interview = 'clinical_interview';
export const record_sessions_assessment = 'assessment';
export const record_sessions_formulation = 'formulation';

export const HIGHEST_ADD_RELATIVE = 6;
export const QUILL_MODULES = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
      ],
};

export const QUILL_FORMATS = [
    'header',
    'bold',
    'italic',
    'underline',
    'list',
    'bullet',
];

export const ADMIN = 'admin';
export const DOCTOR = 'doctor';
export const LOADING_CAPTION = '';


export const apiEndpoints = [
    {
      endPoint: GET_COLLATERAL_REPORT,
      type: "Collateral Report",
      key: "collateral",
    },
    {
      endPoint: GET_BACKGROUND_REPORT_STREAM,
      type: "Background Information",
      key: "background_info",
      stream: true
    },
    {
      endPoint: GET_ASSESMENT_DATA_REPORT_STREAM,
      type: "Assessment Data Report",
      key: "assessment_data",
      stream: true
    },
    {
      endPoint: GET_MENNTAL_STATUS_EXAMINATION_STREAM,
      type: "Mental Status Examination",
      key: "mse",
      stream: true
    },
    {
      endPoint: GET_STANRADISED_ASSESSMENT_STREAM,
      type: "Standardised Assessment",
      key: "standardised_assessment",
      stream: true
    },
    {
      endPoint: GET_CLINICAL_INTERVIEW_STREAM,
      type: "Clinical Interview",
      key: "clinical_interviews",
      stream: true
    },
    {
      endPoint: GET_FORMULATION_STREAM,
      type: "formulation",
      key: "formulation",
      stream: true
    },
    {
      endPoint: GET_DIAGNOSE_STREAM,
      type: "DSM-5-TR/ICD-11 Diagnoses",
      key: "diagnose",
      stream: true
    },
    {
      endPoint: PATIENT_ASSESSMWNT_RECOMMENDED_STREAM,
      type: "Recommendations",
      key: "recommendation",
      stream: true
    },
    {
      endPoint: GET_RECOMMENDATION_STREAM,
      type: "Recommendations",
      key: "recommendations",
      stream: true
    },
  ];